module.exports = __webpack_public_path__ + "img/dd-logo-ford.95a1c0eb.png";